/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChunkRequest
 */
export interface ChunkRequest {
    /**
     * 
     * @type {string}
     * @memberof ChunkRequest
     */
    id: string;
}

/**
 * Check if a given object implements the ChunkRequest interface.
 */
export function instanceOfChunkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ChunkRequestFromJSON(json: any): ChunkRequest {
    return ChunkRequestFromJSONTyped(json, false);
}

export function ChunkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function ChunkRequestToJSON(value?: ChunkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

